document.addEventListener("DOMContentLoaded", () => {
    const swatches = document.querySelectorAll('.variant-option__swatch input[type="radio"]');
    const mediaContainer = document.querySelector('.product-swatch-media');

    if (!mediaContainer) return;

    swatches.forEach((swatch) => {
        swatch.addEventListener('change', () => {
            if (swatch.checked) {
                const variantId = swatch.dataset.variantId;
                const mediaItems = Array.from(mediaContainer.querySelectorAll('.swatch-media-item'));

                const matchingMedia = mediaItems.find(item => item.dataset.variantId === variantId);
                if (matchingMedia) {
                    mediaContainer.prepend(matchingMedia);
                }
            }
        });
    });
});  